export const styles = {
  headingModal: {
    color: "primary.main",
    fontWeight: "medium",
    textTransform: "uppercase",
  },
  confirmContent: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 2,
  },
  mainButton: (isBookingMode) => ({
    width: { xs: "100%", sm: isBookingMode ? "250px" : "auto" },
    minWidth: "150px",
  }),
  textButton: { width: { xs: "100%", sm: "auto" } },
  buttonStack: {
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    p: 2,
    boxSizing: "border-box",
  },
};
